export default __webpack_public_path__ + "static/media/1-1-chooseState.d960d359.png";